module.exports = __webpack_public_path__ + "img/up-red.ad412171.svg";